// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"16d75af4","453":"bb2c32a1","884":"ac2c81df"}[chunkId] + ".chunk.js";
};